import React, { useState } from 'react'
import ClientProvider from '../ClientProvider';

export function deleteCache(wsProvider, callback = () => { }) {
  console.log("Going to Delete Client Cache")
  wsProvider.ws.waitForSocketAndSend({
    action: "deleteCache",
    options: {
      client: wsProvider.clientSelected,
      project_id: wsProvider.selectedProjectId,
      clientConfig: wsProvider.clientConfig
    }
  }, () => {
    callback()
  })
}

export default function ButtonDeleteCache() {
  const wsProvider = React.useContext(ClientProvider);

  const actionHandler = () => {
    deleteCache(wsProvider)
  }

  return (
    <div className="col-1">
      <div className="d-grid gap-2">
        <button
          onClick={actionHandler}
          className="btn btn-primary btn-sm"
          type="button"
          disabled={wsProvider.clientConfig.length > 0 && wsProvider.connectedStatus && !wsProvider.checkIsLoading() ? '' : 'disabled'}
        >
          Delete Cache
        </button>
      </div>
    </div>
  )
}